import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import cx from 'classnames';
import qs from 'query-string';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';
import { CtaType, trackCtaClicked, TrackingProductLocation } from '~/util/trackingHelper';

import { BUDGET_QUIZ_FLOW_NAME } from '../../BudgetQuiz/hooks/budgetQuizTracking';
import { quizUrl } from '../../BudgetQuiz/hooks/quizUrl';
import ZoomMoney from './zoom-money.svg';

import styles from './budgetQuizCard.module.less';

export const BudgetQuizCard = ({
  className,
  noBorder,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & { noBorder?: boolean }) => {
  const { canonicalUrl } = useSearchResultsPageContext();
  return (
    <div className={cx(styles.card, className, { [styles.noBorder]: noBorder })} {...rest}>
      <img src={ZoomMoney} alt="" className={styles.zoomMoney} />
      <div className={styles.dek}>
        <div className={styles.noWrap}>How much</div>{' '}
        <div className={styles.noWrap}>should you spend</div>{' '}
        <div className={styles.noWrap}>
          on your <strong>venue?</strong>
        </div>
      </div>
      <ButtonV3
        component="a"
        onClick={() => {
          trackCtaClicked({
            ctaType: CtaType.BUTTON,
            ctaId: BUDGET_QUIZ_FLOW_NAME,
            location: TrackingProductLocation.SEARCH_RESULTS,
          });
        }}
        // Include the current location to go back to
        href={`${quizUrl}?${qs.stringify({ vendorSearch: canonicalUrl })}`}
        className={styles.button}
        colorway="forest"
        variant="secondary"
      >
        Take the budget quiz
      </ButtonV3>
    </div>
  );
};
